<div class="page-content">
  <div>
    <button class="btn btn-primary" routerLink="/profile">
      <span class="fas fa-chevron-left me-2"></span>
      {{ "admin.common.back" | translate }}
    </button>
  </div>
  <div>
    <h5 class="mb-0">{{ "newProjectIdea.title" | translate }}</h5>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="info-title">{{ "newProjectIdea.infoTitle" | translate }}</div>
      <div class="info-text">
        <p>{{ "newProjectIdea.infoText1" | translate }}</p>
        <p>{{ "newProjectIdea.infoText2" | translate }}</p>
      </div>
    </div>
    <div class="col-8">
      <app-new-project-form />
    </div>
  </div>
</div>
